export default {
    accessToken: null,
    user: null,
    modal: {
        show: false,
        name: "",
        data: {}
    },
    tickets: {
        data: [],
        metadata: {},
        hasViewed: false
    },
    sidebar: {
        show: false
    },
    toast: {
        show: false,
        type: "success",
        timeout: null,
        message: ""
    },
    location: "Qualquer lugar",
    batches: {
        data: [],
        metadata: {}
    }
}